import {API_PATHS} from "./apiPaths";
import {axiosInstance} from "./axiosSetup";

export async function getConductCheckReports(selectedJournalIds) {
  return await axiosInstance.post(API_PATHS.PROXY_PATH, {
    queryStringParameters: {
      journal_ids: selectedJournalIds.join(',')
    },
    path: API_PATHS.CONDUCTCHECK_REPORTS,
    method: "get",
  });
}
